module.exports = "https://web-assets-production.autolist.com/_next/static/images/baseball-b20f8bde0db40357c881f5eda0aa37f5.jpg";